import { Linking, Pressable, StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { useToast } from 'utils/useToast';

import { Icons } from 'components/Icons';

type AvailableIcons =
  | 'instagram'
  | 'facebook'
  | 'twitter'
  | 'bluesky'
  | 'tiktok'
  | 'youtube'
  | 'email'
  | 'wpp';

const IconMap: Record<AvailableIcons, React.ReactNode> = {
  instagram: <Icons.Instagram />,
  facebook: <Icons.Facebook />,
  twitter: <Icons.XTwitter />,
  bluesky: <Icons.Bluesky />,
  tiktok: <Icons.Tiktok />,
  youtube: <Icons.Youtube />,
  email: <Icons.Envelope />,
  wpp: <Icons.Whatsapp />,
};

export type ContactBlockConfig = {
  icon: AvailableIcons;
  description?: string;
  title: string;
  link: string;
};

const ContactBlock: React.FC<ContactBlockConfig> = (props) => {
  const { icon, link, title, description } = props;
  const toast = useToast();

  const handleOnPress = () => {
    Linking.openURL(link).catch((e) => {
      console.error(e);

      return toast.show({
        mode: 'error',
        title: 'Ops 😢',
        description: 'Ocorreu um erro inexperado!',
      });
    });
  };

  if (!IconMap[icon] || !title || !link) return null;

  return (
    <Pressable style={styles.pressable} onPress={handleOnPress}>
      <View style={styles.vStack}>
        <View style={styles.spacing}>{IconMap[icon]}</View>
        {description && <Text style={[styles.description, styles.spacing]}>{description}</Text>}
        <Text style={styles.title}>{title}</Text>
      </View>
    </Pressable>
  );
};
const styles = StyleSheet.create({
  pressable: {
    flex: 1,
  },
  vStack: {
    backgroundColor: '#FFFFFF10', // Ajuste para string fixa, pois template string não é suportada
    borderRadius: 16, // $lg (ajuste conforme seu theme)
    paddingVertical: 32, // $8 equivale a 32px
    paddingHorizontal: 16, // $4 equivale a 16px
  },
  spacing: {
    marginBottom: 4, // $1 equivale a 4px
  },
  icon: {
    marginBottom: 0,
  },
  description: {
    color: theme.colors.base.white,
    fontSize: theme.fontSizesPx.md,
    fontFamily: 'system-ui',
    lineHeight: 22,
  },
  title: {
    fontWeight: 'bold',
    color: theme.colors.base.purple,
    fontSize: theme.fontSizesPx.md,
    fontFamily: 'system-ui',
    lineHeight: 22,
  },
});

export default ContactBlock;
